import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { theme, UserAvatar } from '@side/pantry';
import { useSearchParams } from 'next/navigation';
import { useAgentAccountProfileUserQuery } from '../../views/agent-account-profile/agent-account-profile.generated';
import { UploadImageModal } from '../UploadImageModal';
import { useAccountSettingsLogic } from './useAccountSettingsLogic';

export const AccountSettingsMobileHeader = () => {
  const searchParams = useSearchParams();
  const { data: userResponse, loading: userQueryLoading } =
    useAgentAccountProfileUserQuery({
      errorPolicy: 'all',
    });
  const userName = userResponse?.me?.record;

  const teamId =
    searchParams?.get('team') ?? userResponse?.me?.record?.agentTeam?.id;
  const userId = userName?.id;

  const {
    user,
    name,
    teams,
    avatarEditModalOpen,
    setAvatarEditModalOpen,
    loadingUpdateAvatar,
    onSubmitAvatar,
  } = useAccountSettingsLogic(userId ?? '');

  const selectedTeam = teams.find((team) => team?.id === teamId);
  const selectedTeamName = selectedTeam?.alias ?? selectedTeam?.legalName ?? '';

  return (
    <>
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <UserAvatar
            name={name}
            avatarUrl={user?.photoUrl || ''}
            sx={{ height: { xs: 70, lg: 50 }, width: { xs: 70, lg: 50 } }}
          />
          <IconButton
            aria-label="Edit avatar"
            onClick={() => setAvatarEditModalOpen(true)}
            sx={{
              position: 'absolute',
              bottom: { xs: 0, lg: 5 },
              right: { xs: 0, lg: 5 },
              backgroundColor: 'primary.main',
              color: 'common.white',
              width: theme.spacing(3),
              height: theme.spacing(3),
              '&:hover': { backgroundColor: 'primary.dark' },
            }}
          >
            <EditOutlinedIcon sx={{ fontSize: theme.spacing(2) }} />
          </IconButton>
        </Box>
        <Stack sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1">
            {!name || userQueryLoading
              ? 'Welcome'
              : `Welcome, ${user?.firstName}`}
          </Typography>
          <Typography
            variant="subtitle1"
            data-testid="selected-team-name"
            sx={{
              color: 'text.secondary',
            }}
          >
            {selectedTeamName}
          </Typography>
        </Stack>
      </Stack>
      <UploadImageModal
        key={user?.photoUrl || 'new'}
        title="Select a photo"
        headline={
          <>
            Upload a new photo for <b>{name}</b>
          </>
        }
        open={avatarEditModalOpen}
        onClose={() => setAvatarEditModalOpen(false)}
        onSubmit={onSubmitAvatar}
        uploading={loadingUpdateAvatar}
        imageUrl={user?.photoUrl || ''}
      />
    </>
  );
};
